import React, { useState } from 'react';
import { Button } from './Button';
import { ArrowRightIcon, ArrowLeftIcon } from 'lucide-react';
interface Question {
  id: string;
  text: string;
  type: 'text' | 'scale' | 'choice';
  choices?: string[];
}
interface QuestionFlowProps {
  questions: Question[];
  onComplete: () => void;
  onSkip?: () => void;
}
const QuestionFlow: React.FC<QuestionFlowProps> = ({
  questions,
  onComplete,
  onSkip
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState<Record<string, any>>({});
  const handleNext = () => {
    if (currentIndex < questions.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      onComplete();
    }
  };
  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };
  const handleAnswer = (value: any) => {
    setAnswers({
      ...answers,
      [questions[currentIndex].id]: value
    });
  };
  const currentQuestion = questions[currentIndex];
  return <div className="w-full max-w-xl mx-auto" data-id="element-970">
      <div className="mb-8 flex justify-between items-center" data-id="element-971">
        <div className="flex space-x-1" data-id="element-972">
          {questions.map((_, index) => <div key={index} className={`w-8 h-1 rounded-full ${index <= currentIndex ? 'bg-gray-800' : 'bg-gray-300'}`} data-id="element-973"></div>)}
        </div>
        <span className="text-sm text-gray-500" data-id="element-974">
          {currentIndex + 1}/{questions.length}
        </span>
      </div>
      <div className="mb-12" data-id="element-975">
        <h2 className="text-2xl font-light text-gray-800 mb-8" data-id="element-976">
          {currentQuestion.text}
        </h2>
        {currentQuestion.type === 'text' && <textarea className="w-full h-32 p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-gray-400 resize-none" placeholder="Typ je antwoord hier..." value={answers[currentQuestion.id] || ''} onChange={e => handleAnswer(e.target.value)} data-id="element-977"></textarea>}
        {currentQuestion.type === 'scale' && <div className="py-6" data-id="element-978">
            <div className="flex justify-between items-center" data-id="element-979">
              {[1, 2, 3, 4, 5].map(value => <button key={value} className={`w-12 h-12 rounded-full flex items-center justify-center transition-colors duration-200 ${answers[currentQuestion.id] === value ? 'bg-gray-200 border-2 border-gray-400' : 'border-2 border-gray-300 hover:bg-gray-100'}`} onClick={() => handleAnswer(value)} data-id="element-980">
                  <span className="text-lg text-gray-700" data-id="element-981">{value}</span>
                </button>)}
            </div>
            <div className="flex justify-between mt-2 text-sm text-gray-600" data-id="element-982">
              <span data-id="element-983">Helemaal niet</span>
              <span data-id="element-984">Zeer sterk</span>
            </div>
          </div>}
        {currentQuestion.type === 'choice' && currentQuestion.choices && <div className="space-y-3" data-id="element-985">
            {currentQuestion.choices.map(choice => <button key={choice} className={`w-full p-4 text-left border rounded-lg transition-colors duration-200 ${answers[currentQuestion.id] === choice ? 'border-gray-400 bg-gray-100' : 'border-gray-300 hover:bg-gray-50'}`} onClick={() => handleAnswer(choice)} data-id="element-986">
                {choice}
              </button>)}
          </div>}
      </div>
      <div className="flex justify-between" data-id="element-987">
        <Button variant="secondary" onClick={handlePrevious} disabled={currentIndex === 0} leftIcon={<ArrowLeftIcon className="w-4 h-4" data-id="element-989" />} data-id="element-988">
          Vorige
        </Button>
        <div className="flex space-x-3" data-id="element-990">
          {onSkip && <Button variant="tertiary" onClick={onSkip} data-id="element-991">
              Overslaan
            </Button>}
          <Button onClick={handleNext} rightIcon={<ArrowRightIcon className="w-4 h-4" data-id="element-993" />} data-id="element-992">
            {currentIndex < questions.length - 1 ? 'Volgende' : 'Afronden'}
          </Button>
        </div>
      </div>
    </div>;
};
export default QuestionFlow;